import React from 'react';

const LocationIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    {...props}
  >
    <path
      d="M8.0785 13.7448C7.78937 14.0155 7.40293 14.1668 7.00074 14.1668C6.59856 14.1668 6.21212 14.0155 5.92299 13.7448C3.27535 11.2508 -0.272825 8.46478 1.45751 4.41994C2.39309 2.23293 4.6389 0.833496 7.00074 0.833496C9.36259 0.833496 11.6084 2.23293 12.544 4.41994C14.2721 8.45968 10.7327 11.2594 8.0785 13.7448Z"
      stroke="#002564"
      strokeOpacity="0.5"
    />
    <path
      d="M9.33366 6.83333C9.33366 8.122 8.28899 9.16667 7.00033 9.16667C5.71166 9.16667 4.66699 8.122 4.66699 6.83333C4.66699 5.54467 5.71166 4.5 7.00033 4.5C8.28899 4.5 9.33366 5.54467 9.33366 6.83333Z"
      stroke="#002564"
      strokeOpacity="0.5"
    />
  </svg>
);

export default LocationIcon;
